import { WorkerRequirementStatus } from "@clipboard-health/contract-worker-app-bff";

import { useRequirementDetailsContext } from "../../useRequirementDetailsContext";
import { ProfessionalReferencesApprovedView } from "./components/ApprovedView";
import { ProfessionalReferencesWorkflowView } from "./components/WorkflowView";

/**
 * Professional References Page
 * Routes between approved view and workflow view based on requirement status
 */
export function DocumentDetailsProfessionalReferencesWorkflowPage() {
  const { requirement: workerRequirement } = useRequirementDetailsContext();
  const isRequirementApproved = workerRequirement?.status === WorkerRequirementStatus.APPROVED;

  if (isRequirementApproved) {
    return <ProfessionalReferencesApprovedView />;
  }

  return <ProfessionalReferencesWorkflowView />;
}
